import { render, staticRenderFns } from "./QLongReadonly.vue?vue&type=template&id=6181ca64&scoped=true"
import script from "./QLongReadonly.vue?vue&type=script&lang=js"
export * from "./QLongReadonly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6181ca64",
  null
  
)

export default component.exports